<template>
  <v-text-field
    :model-value="modelValue ?? value"
    @update:model-value="onUpdate"
    @change="load();"
    @click:clear="reset();"
    @keyup="load();"
    label="Search"
    variant="outlined"
    density="compact"
    hide-details
    clearable
    class="subnav-header-field d-inline-block mx-1"
  ></v-text-field>
</template>

<script>
export default {
  name: 'BaseViewHeaderSearch',

  props: {
    modelValue: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: '',
    },
    search: {
      type: Function,
      default: () => {},
    },
  },

  emits: ['update:modelValue', 'input'],

  data() {
    return {
      previousValue: '',
    };
  },

  computed: {
    currentValue() {
      return this.modelValue ?? this.value;
    },
  },

  watch: {
    currentValue() {
      this.load();
    },
  },

  methods: {
    onUpdate(val) {
      this.$emit('update:modelValue', val);
      this.$emit('input', val);
    },

    reset() {
      this.previousValue = '';
      this.onUpdate('');
      this.search();
    },

    load() {
      if (this.currentValue == this.previousValue) return;
      this.previousValue = this.currentValue;
      this.search();
    },
  },
};
</script>
